<script setup lang="ts">
  import { computed } from 'vue'
  import { useColorMode } from '@vueuse/core'
  import { Loader2 } from 'lucide-vue-next'

  type LoaderStatus = 'loading' | 'error' | 'ready'

  interface LoaderState {
    status: LoaderStatus
    message?: string
    version?: string
  }

  defineProps<{
    state: LoaderState
  }>()

  const { system, store } = useColorMode()
  const mode = computed(() => (store.value === 'auto' ? system.value : store.value))
</script>

<template>
  <div class="flex min-h-screen flex-col items-center justify-center">
    <img
      :src="
        mode === 'dark'
          ? 'https://cdn.aplos-nca.com/assets/MonoLogoWhite.svg'
          : 'https://cdn.aplos-nca.com/assets/ColorLogo.svg'
      "
      class="mb-4 h-14"
      alt="Loading Logo"
    />
    <template v-if="state.status === 'loading'">
      <Loader2 class="animate-spin" :size="48" />
      <p v-if="state.version" class="mt-2 text-sm text-gray-400">Version {{ state.version }}</p>
    </template>

    <template v-else-if="state.status === 'error'">
      <div class="mt-4 text-center">
        <p class="font-semibold text-red-600">{{ state.message || 'An error occurred.' }}</p>
      </div>
      <p v-if="state.version" class="mt-2 text-sm text-gray-400">Version {{ state.version }}</p>
    </template>
  </div>
</template>
